import React, { useEffect } from "react";
import DashboardStyle from "../../../../dashboard/Styles/Dashboard.module.css";
import PageLayout from "../../../Components/Layout/PageLayout";
import { FormTemplate } from "../../../Components/Forms/InputTemplate";
import { FormProvider, useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { GetSingleJobListing } from "../../../../../utils/redux/HR/HRSlice";
// import { FormatCurrency } from "../../../../../utils/functions/FormatCurrency";

function RecruitmentProcessDetails() {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const formMethods = useForm({
    mode: "all",
  });

  const { handleSubmit } = formMethods;

  const { get_singlejoblisting } = useSelector((state) => state?.hr);

  const acq = get_singlejoblisting?.responseObject;

  // Fetch Redux data
  const { get_singlequalification } = useSelector((state) => state?.hr);

  const qualifications = get_singlequalification?.responseObject || [];

  useEffect(() => {
    dispatch(GetSingleJobListing({ Id: id }));
  }, [dispatch, id]);

  return (
    <PageLayout title={"Recruitment Process Details"} hasBack={true}>
      <div className={DashboardStyle.app_view_controls}></div>
      <FormProvider>
        <FormTemplate
          className={DashboardStyle.view_app_components}
          // handleSubmit={handleSubmit(submit)}
        >
          {/* Process Information Section */}
          <section
            style={{
              backgroundColor: "#F8FBF8",
              border: "1px solid #D9E9DA",
              borderRadius: "8px",
            }}
            className={DashboardStyle.form_section}
          >
            <h4 className={DashboardStyle.form_section_title}>
              Process <br /> Information
            </h4>
            <div className={DashboardStyle.labels_group}>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fill, minmax(32.3%, 1fr))",
                  gap: "10px",
                }}
              >
                <div>
                  <p>Process Type:</p>
                  <h4>Recruitment Process</h4>
                </div>
                <div>
                  <p>Date Initiated:</p>
                  <h4>
                    {new Date(acq?.createdDate).toLocaleDateString() || "N/A"}
                  </h4>
                </div>
                <div>
                  <p>Approval Status:</p>
                  <h4>{acq?.approvalStatusEnum || "N/A"}</h4>
                </div>
                <div>
                  <p>Applicants:</p>
                  <h4>{acq?.jobListingChannels?.length || 0}</h4>
                </div>
              </div>
            </div>
          </section>

          {/* Basic Information Section */}
          <section
            style={{
              backgroundColor: "#F8FBF8",
              border: "1px solid #D9E9DA",
              borderRadius: "8px",
            }}
            className={DashboardStyle.form_section}
          >
            <h4 className={DashboardStyle.form_section_title}>
              Basic <br /> Information
            </h4>
            <div className={DashboardStyle.labels_group}>
              <div>
                <p>Job Title:</p>
                <h4>{acq?.jobTitle?.title || "N/A"}</h4>
              </div>
              <div>
                <p>Years of Experience:</p>
                <h4>{acq?.yearsOfExperience || "N/A"}</h4>
              </div>
              <section className="my-2">
                {/* font-size: 0.875rem;
              font-weight: 400; */}
                <div>
                  <p
                    style={{
                      color: "var(--form_title)",
                      fontSize: "0.75rem",
                      lineHeight: "1rem",
                      marginBottom: "0.65rem",
                    }}
                  >
                    Job Responsibility:
                  </p>
                  <ul className="space-y-2">
                    {acq?.jobTitle?.jobResponsibilities?.map((r, idx) => (
                      <li
                        style={{
                          fontSize: "0.875rem",
                          fontWeight: "400",
                          listStyle: "disc",
                        }}
                        key={idx}
                      >{` ${r?.jobDescription || "N/A"}`}</li>
                    )) || "N/A"}
                  </ul>
                </div>
              </section>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fill, minmax(32.3%, 1fr))",
                  gap: "10px",
                }}
              >
                <div>
                  <p>Work Mode:</p>
                  <h4>Hybrid</h4> {/* Placeholder; replace if available */}
                </div>
                <div>
                  <p>Opening Date:</p>
                  <h4>
                    {new Date(acq?.openingDate).toLocaleDateString() || "N/A"}
                  </h4>
                </div>
                <div>
                  <p>Closing Date:</p>
                  <h4>
                    {new Date(acq?.closingDate).toLocaleDateString() || "N/A"}
                  </h4>
                </div>
              </div>
              <div>
                <p>Qualification:</p>
                {/* <h4>{qualifications?.qualification || "N/A"}</h4> */}
                <ul>
                  {acq?.jobListingQualifications?.map((s, idx) => (
                    <li
                      style={{
                        fontSize: "0.875rem",
                        fontWeight: "400",
                        listStyle: "disc",
                      }}
                      key={idx}
                    >{`${s.qualification?.description || "N/A"}`}</li>
                  )) || "N/A"}
                </ul>
              </div>
              <div>
                <p>Skills:</p>
                {/* <h4>{skills?.name || "N/A"}</h4> */}
                <ul>
                  {acq?.jobListingSkills?.map((s, idx) => (
                    <li
                      style={{
                        fontSize: "0.875rem",
                        fontWeight: "400",
                        listStyle: "disc",
                      }}
                      key={idx}
                    >{`${s.skill?.name || "N/A"}`}</li>
                  )) || "N/A"}
                </ul>
              </div>
              <div>
                <p>Channel:</p>
                <ul>
                  {acq?.jobListingChannels?.map((c, idx) => (
                    <li
                      style={{
                        fontSize: "0.875rem",
                        fontWeight: "400",
                        listStyle: "disc",
                      }}
                      key={idx}
                    >{`${c.channel?.channel || "N/A"}`}</li>
                  )) || "N/A"}
                </ul>
              </div>
            </div>
          </section>

          {/* Action Buttons */}
          {/* <div className={DashboardStyle.button_cage}>
            <button
              width={"auto"}
              className={DashboardStyle?.button_cage_weight}
              onClick={() => approve()}
            >
              Approve
            </button>
            <ActionButtons
              width={"auto"}
              className={DashboardStyle?.button_cage_weight}
              style={{ backgroundColor: "red" }}
              onClick={() => decline()}
            >
              Decline
            </ActionButtons> 
          </div>*/}
        </FormTemplate>
      </FormProvider>
    </PageLayout>
  );
}

export default RecruitmentProcessDetails;
